var _path, _path2, _path3, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFlagHovered(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 20.002V3",
    stroke: "#223944",
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 3.08845C4.5 3.08845 6.3612 2.84571 8.59895 3.28419C10.8367 3.72267 11.8353 4.78451 13.2313 5.42168C14.6274 6.05885 15.2383 6.04316 16.7762 5.96978C18.3462 5.89487 20.5 4.84485 20.5 4.84485L16.924 10.7793L20.5 15.002",
    stroke: "url(#paint0_linear_1782_23251)",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 13.5884C4.5 13.5884 6.3612 13.3459 8.59895 13.7839C10.8367 14.222 11.8353 15.2828 13.2313 15.9193C14.6274 16.5559 15.2383 16.5402 16.7762 16.4669C18.3462 16.392 20.1969 15.5221 20.5 15.343",
    stroke: "url(#paint1_linear_1782_23251)",
    strokeLinecap: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1782_23251",
    x1: 30.6782,
    y1: 24.6856,
    x2: 28.1105,
    y2: 7.03732,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#223944",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#223944"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1782_23251",
    x1: 29.5936,
    y1: 18.5649,
    x2: 29.4329,
    y2: 14.4264,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#223944",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#223944"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagHovered);
export default __webpack_public_path__ + "static/media/flagHovered.0ce159a4f7bedd2dd9c95790a8f234be.svg";
export { ForwardRef as ReactComponent };